import React, { useRef, useEffect, useState } from "react";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import { Account_Rights } from "../../Configuration/API_URL";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm, useFieldArray } from "react-hook-form";
import RoundLoader from "../../Components/Common/RoundRingLoader";
import Loader from "../../Components/Common/Loader";
import { error } from "jquery";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import {
  AESEncryption,
  ApiResDecrypt,
  formatDate,
  getClientsRawData,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import axiosInstance from "../../CommonMethhods/axiosInstance";
// import { onlyNumber } from "../../CommonMethhods/CommonMethods";

function AccountRights() {
  const storeToken = localStorage.getItem("ssoToken");
  const [accountRightsTableData, setAccountRightsTableData] = useState([]);
  const [downloadBtnLoader, setDownloadBtn] = useState(false);
  const [insertBtnLoader, setInsertloadBtn] = useState(false);
  const [rejectBtnLoader, setRejectBtnLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [mainError, setMainError] = useState(false);
  const typeRef = useRef("");

  const handleProductType = (e) => {
    setAccountRightsTableData([]);
  };
  //   get account rights detail
  const getAccountRightsDetailList = async (typeView = "grid", apCode) => {
    if (typeView === "grid") {
      setLoader(true);
    }
    let payloadValue = {
      type: typeView,
      productType: "brokerage",
      apCode: apCode || "",
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getAccountRightsList = await axiosInstance.post(
        Account_Rights.GetAccountRightsData_URL,
        `"${encPayload}"`,
      );
      const response = ApiResDecrypt(getAccountRightsList?.data);
      let res1, res;
      if (typeView === "excel") {
        res1 = response.data;
      } else if (typeView === "grid") {
        setMainError(false);
        res = response.data.acBrokerages;
      }

      if (res || res1) {
        if (typeView === "grid") {
          setMainError(false);

          setAccountRightsTableData(res);
        } else if (typeView === "excel") {
          window.open(res1, "_self", "noopener,noreferrer");
          toast.success("Excel downloaded successfully");
        }
      } else {
        setMainError(response.message);
      }
    } catch (error) {
      console.log(error);
      setMainError(error.message);
    } finally {
      setDownloadBtn(false);
      setLoader(false);
    }
  };

  useEffect(() => {
    // if (typeRef.current.value !== "") {
    getAccountRightsDetailList("grid");
    // }
  }, []);
  //end account rights detail

  //   // update account rights table
  const insertAccountRightsDetail = async (new_users) => {
    let payloadValue = { accountRights: new_users };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getAccountRightsList = await axiosInstance.post(
        Account_Rights.InsertAccountRightsData_URL,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getAccountRightsList?.data);
      if (res.status === 0) {
        toast.success(res.data);
        getAccountRightsDetailList("grid");
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong, Please try again later.");
    } finally {
      setInsertloadBtn(false);
      setRejectBtnLoader(false);
    }
  };

  //   //end update

  const AccountRightSchema = Yup.object().shape({
    AccountRightsKey: Yup.array().of(
      Yup.object().shape({
        apCode: Yup.string(),
        apName: Yup.string(),
        gstRegistered: Yup.number(),
        module: Yup.number(),
        month: Yup.number(),
        fromDate: Yup.string(),
        toDate: Yup.string(),
        brokerage: Yup.number(),
        exchange: Yup.number(),
        sharing: Yup.number(),
        finalAmount: Yup.number(),
        lessTDS: Yup.number(),
        payoutAfterTDS: Yup.number(),
        netRisk: Yup.number(),
        // netAmt: Yup.number().required("Net Amt is Required"),
        netRiskAmt: Yup.number(),
        fnHolAmt: Yup.number(),
        fnncHolAmt: Yup.number().required("Amt by Finance Team required"),
        netAmt: Yup.number(),
        remark: Yup.string(),
        acApprove: Yup.boolean().required("Select a row"),
      })
    ),
  });

  const optionsDf = { resolver: yupResolver(AccountRightSchema) };
  const {
    control,
    formState,
    handleSubmit,
    register,
    watch,
    reset,
    setValue,
    getValues,
    setError,
    clearErrors,
  } = useForm(optionsDf);
  const { errors } = formState;
  const { fields: accountRightsField } = useFieldArray({
    name: "AccountRightsKey",
    control,
  });

  useEffect(() => {
    reset({
      AccountRightsKey: accountRightsTableData,
    });
  }, [accountRightsTableData]);

  const handleType = () => {
    setDownloadBtn(true);
    getAccountRightsDetailList("excel");
  };
  // const downloadEachRecord = (apcode) => {
  //   if (typeRef.current.value !== "" && apcode != null) {
  //     // setDownloadBtn(true);
  //     getAccountRightsDetailList("excel", apcode);
  //   }
  // };

  const approveInsertBtn = async () => {
    let accountRightsFinalData = { ...getValues() };
    let individualTrue = document.querySelectorAll(".activeData");
    let SubmitArray = [];
    for (let individualdata of individualTrue) {
      if (individualdata.checked && individualdata.disabled != true) {
        const data =
          accountRightsFinalData.AccountRightsKey[`${individualdata.id}`];
        // delete data.rmApprove;
        // delete data.apApproved;
        // data.acApprove = JSON.parse(data.acApprove);
        const filteredData = {
          apCode: data?.apCode || "",
          financeStatus: "Approved",
          financeRemarks: data?.financeRemarks || "",
        };
        SubmitArray.push(filteredData);
      }
    }

    if (SubmitArray.length == 0) {
      toast.error("Choose atleast 1 item to Approve");
      return;
    }
    setInsertloadBtn(true);
    insertAccountRightsDetail(SubmitArray);
  };

  const rejectInsertBtn = async () => {
    let remarkValue;
    let accountRightsFinalData = { ...getValues() };
    let individualTrue = document.querySelectorAll(".activeData");
    let SubmitArray = [];
    for (let individualdata of individualTrue) {
      if (individualdata.checked && individualdata.disabled != true) {
        const data =
          accountRightsFinalData.AccountRightsKey[`${individualdata.id}`];
        remarkValue =
          getValues(`AccountRightsKey.${individualdata.id}.financeRemarks`) ||
          "";

        // delete data.rmApprove;
        // delete data.apApproved;
        // data.acApprove = JSON.parse(data.acApprove);
        const filteredData = {
          apCode: data?.apCode || "",
          financeStatus: "Rejected",
          financeRemarks: remarkValue || data?.financeRemarks || "",
        };
        SubmitArray.push(filteredData);
      }
    }

    if (SubmitArray.length == 0) {
      toast.error("Choose atleast 1 item to Reject");
      return;
    }
    if (remarkValue?.length > 0) {
      setRejectBtnLoader(true);
      insertAccountRightsDetail(SubmitArray);
    } else {
      toast.error("Please enter rejecting Remarks");
      setRejectBtnLoader(false);
    }
  };

  useEffect(() => {
    if (errors) {
      console.log(errors);
      for (let acKey of errors.AccountRightsKey ?? []) {
        if (acKey) {
          const key = Object.keys(acKey)[0];
          toast.error(acKey[key].message);
          break;
        }
      }
    }
  }, [errors]);

  const singleInputChange = (e) => {
    if (e.target.checked) {
      let AllCheck = [];
      let individualTrue = document.querySelectorAll(".activeData");
      for (let data of individualTrue) {
        AllCheck.push(data.checked);
      }
      if (AllCheck.includes(false)) {
        document.getElementById("select-all-rights").checked = false;
      } else {
        document.getElementById("select-all-rights").checked = true;
      }
    } else {
      document.getElementById("select-all-rights").checked = e.target.checked;
    }
  };
  const selectAllChange = (e) => {
    let individualTrue = document.querySelectorAll(".activeData");
    for (let data of individualTrue) {
      data.checked = e.target.checked;
    }
  };

  const handleFnncChange = (e, i) => {
    setValue(
      `AccountRightsKey.${i}.netAmt`,
      getValues(`AccountRightsKey.${i}.netRiskAmt`) -
        getValues(`AccountRightsKey.${i}.fnHolAmt`) -
        Number(e.target.value)
    );
  };
  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="accountRights-wrapper">
        <div className="card-box ">
          <div className="tableHead">
            <h4 className="accountRights-title">Finance Rights Table</h4>
          </div>
          <form className="row input-field-wrapper">
            <div className="col-md-3 col-sm-6 col-12">
              <div className="form-group">
                <select
                  className="report-custom-select product-select"
                  // onChange={handleProductType}
                  ref={typeRef}
                >
                  {/* <option value="">--Select Type--</option> */}
                  <option
                    value="brokerage"
                    defaultChecked
                    style={{ display: "none" }}
                  >
                    Brokerage
                  </option>
                  {/* <option value="mtf/las">MTF</option>
                  <option value="amc">AMC</option>
                  <option value="slab wise">Slab Wise</option> */}
                </select>
              </div>
            </div>
          </form>

          {loader ? (
            <div className="report-error-message">
              <Loader />
            </div>
          ) : accountRightsField &&
            accountRightsField.length > 0 &&
            typeRef.current.value !== "" ? (
            <>
              <div className="d-flex justify-content-end">
                <button
                  className="downloadBtnaccountRights1"
                  onClick={() => getClientsRawData()}
                >
                  Raw Download
                </button>
                <button
                  className="downloadBtnaccountRights"
                  onClick={handleType}
                >
                  {downloadBtnLoader ? (
                    <div className="download-loader">
                      <RoundLoader h={"20"} />
                    </div>
                  ) : (
                    "Download"
                  )}
                </button>
              </div>

              <div className="scroll-table accountRights-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col" className="text-center">
                        {
                          <input
                            type="checkbox"
                            id="select-all-rights"
                            onChange={(e) => selectAllChange(e)}
                          />
                        }
                      </th>
                      <th scope="col">AP Code</th>
                      <th scope="col">SAP Code</th>
                      <th scope="col">AP Name</th>
                      <th scope="col">Period From</th>
                      <th scope="col">Period To</th>
                      <th scope="col">Module</th>
                      <th scope="col">Pan No</th>
                      <th scope="col">GST No</th>
                      <th scope="col">Actual Gross Brokerage</th>
                      <th scope="col">Gross Brokerage</th>
                      <th scope="col">AP Sharing %</th>
                      <th scope="col">Net Brokerage</th>
                      <th scope="col">GST 18%</th>
                      <th scope="col">Total Invoice</th>
                      <th scope="col">TDS 5%</th>
                      <th scope="col">AP Ledger</th>
                      <th scope="col">AP Risk</th>
                      <th scope="col">Airtel Charges</th>
                      <th scope="col">Deposit to be Adjusted</th>
                      <th scope="col">Deposit Amount</th>
                      <th scope="col">AP AMC</th>
                      <th scope="col">Other Deductions FR</th>
                      <th scope="col">Other Deductions Fin</th>
                      <th scope="col">Final Payout</th>
                      <th scope="col">NSE Registered</th>
                      <th scope="col">BSE Registered</th>
                      <th scope="col">Franchisee Team Approval Status</th>
                      <th scope="col">Franchisee Team Remarks</th>
                      <th scope="col">RMS Team Approval Status</th>
                      <th scope="col">RMS Team Remarks</th>
                      <th scope="col">Finance Team Approval Status</th>
                      <th scope="col">Finance Team Remarks</th>
                      <th scope="col">Banking Team Approval Status</th>
                      <th scope="col">Banking Team Remarks</th>
                    </tr>
                  </thead>

                  <tbody>
                    {" "}
                    {accountRightsField.map((item, i) => (
                      <>
                        <tr key={i}>
                          <td>
                            <div>
                              <input
                                className={`form-check-input ${
                                  getValues(`AccountRightsKey.${i}.financeStatus`) === "Approved"
                                    ? "inActive"
                                    : "activeData"
                                }`}
                                defaultChecked={
                                  getValues(`AccountRightsKey.${i}.financeStatus`) === "Approved"
                                }
                                disabled={
                                  getValues(`AccountRightsKey.${i}.financeStatus`) === "Approved"
                                }
                                type="checkbox"
                                id={i}
                                value={i}
                                onChange={(e) => singleInputChange(e)}
                              />
                            </div>
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(`AccountRightsKey.${i}.apCode`)}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(`AccountRightsKey.${i}.sapCode`)}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(`AccountRightsKey.${i}.apName`)}
                            />
                          </td>

                          <td>
                              <input
                                className="plane-input"
                                readOnly
                                value={
                                  getValues(`AccountRightsKey.${i}.periodFrom`)
                                    ? formatDate(
                                        getValues(
                                          `AccountRightsKey.${i}.periodFrom`
                                        )?.split(" ")[0]
                                      )
                                    : " "
                                }
                                // {...register(`ApPayout.${i}.periodFrom`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                value={
                                  getValues(`AccountRightsKey.${i}.periodTo`)
                                    ? formatDate(
                                        getValues(
                                          `AccountRightsKey.${i}.periodTo`
                                        )?.split(" ")[0]
                                      )
                                    : " "
                                }
                                // {...register(`ApPayout.${i}.periodTo`)}
                              />
                            </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(`AccountRightsKey.${i}.module`)}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(`AccountRightsKey.${i}.pan`)}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(`AccountRightsKey.${i}.gstNo`)}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(
                                `AccountRightsKey.${i}.actualGrossBrokerage`
                              )}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(
                                `AccountRightsKey.${i}.grossBrokerage`
                              )}
                            />
                          </td>

                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(`AccountRightsKey.${i}.apSharing`)}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(
                                `AccountRightsKey.${i}.netBrokerage`
                              )}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(`AccountRightsKey.${i}.gst18Perc`)}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(
                                `AccountRightsKey.${i}.totalInvoice`
                              )}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(`AccountRightsKey.${i}.tds5Perc`)}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(`AccountRightsKey.${i}.apLedger`)}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(`AccountRightsKey.${i}.apRisk`)}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(
                                `AccountRightsKey.${i}.airtelCharges`
                              )}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(
                                `AccountRightsKey.${i}.depositToBeAdjusted`
                              )}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(`AccountRightsKey.${i}.depositAmt`)}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(`AccountRightsKey.${i}.apAMC`)}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(
                                `AccountRightsKey.${i}.otherDeductionFR`
                              )}
                            />
                          </td>
                          <td>
                            <input
                              className="onChange-field"
                              defaultValue={getValues(
                                `AccountRightsKey.${i}.otherDeductionFin`
                              )}
                              type="number"
                              {...register(
                                `AccountRightsKey.${i}.otherDeductionFin`
                              )}
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(
                                  /^\s+/,
                                  ""
                                );
                              }}
                              disabled={
                                getValues(
                                  `AccountRightsKey.${i}.financeStatus`
                                ) === "Approved"
                              }
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(`AccountRightsKey.${i}.finalPayout`)}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(
                                `AccountRightsKey.${i}.nseRegistered`
                              )}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(
                                `AccountRightsKey.${i}.bseRegistered`
                              )}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(
                                `AccountRightsKey.${i}.franchiseeStatus`
                              )}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(
                                `AccountRightsKey.${i}.franchiseeRemarks`
                              )}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(`AccountRightsKey.${i}.rmsStatus`)}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(`AccountRightsKey.${i}.rmsRemarks`)}
                            />
                          </td>

                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(
                                `AccountRightsKey.${i}.financeStatus`
                              )}
                            />
                          </td>

                          <td>
                            <input
                              className="onChange-field"
                              defaultValue={getValues(
                                `AccountRightsKey.${i}.financeRemarks`
                              )}
                              {...register(
                                `AccountRightsKey.${i}.financeRemarks`
                              )}
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(
                                  /^\s+/,
                                  ""
                                );
                              }}
                              disabled={
                                getValues(
                                  `AccountRightsKey.${i}.financeStatus`
                                ) === "Approved"
                              }
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(
                                `AccountRightsKey.${i}.bankingStatus`
                              )}
                            />
                          </td>
                          <td>
                            <input
                              className="plane-input"
                              readOnly
                              {...register(
                                `AccountRightsKey.${i}.bankingRemarks`
                              )}
                            />
                          </td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </table>
              </div>

              <p className="pt-5" style={{ fontSize: "1.5rem" }}>
                {" "}
                Total No Of Records : {accountRightsField.length}
              </p>
              <div className="wrap-buttons">
                <div className="approve-reject-btn">
                  <button
                    value="grid"
                    className="approve-btn"
                    onClick={approveInsertBtn}
                  >
                    {insertBtnLoader ? (
                      <div className="download-loader">
                        <RoundLoader h={"10"} />
                      </div>
                    ) : (
                      "Approve"
                    )}
                  </button>
                </div>

                <div className="approve-reject-btn">
                  <button
                    value="grid"
                    className="reject-btn"
                    onClick={rejectInsertBtn}
                  >
                    {rejectBtnLoader ? (
                      <div className="download-loader">
                        <RoundLoader h={"10"} />
                      </div>
                    ) : (
                      "Reject"
                    )}
                  </button>
                </div>
              </div>
            </>
          ) : (
            mainError && (
              <div className="report-error-message">
                {noDataFound(mainError)}
              </div>
            )
          )}
        </div>
      </main>
    </>
  );
}

export default AccountRights;
